import latest from './v8.json' with {type: 'json'};
export {latest};
export default latest as any;
